import store from "./store.js";
import { roundToNearestFixed, roundToNearestFixedRange } from "./utility.js";

let conversions = () => [
  { 
    unitFrom: "fahrenheit",
    unitTo: "celsius",
    convertValue: (value) => (value - 32) * 5 / 9,
    unconvertValue: (value) => (value * 9 / 5) + 32
  },
  { 
    unitFrom: "fahrenheit-diff",
    unitTo: "celsius-diff",
    convertValue: (value) => value * 5 / 9,
    unconvertValue: (value) => (value * 9 / 5)
  }
];

function getPreferredUnits(temperaturePreference) {
  if (temperaturePreference == null || temperaturePreference == "fahrenheit")
    return [ "fahrenheit", "fahrenheit-diff" ];
  else
    return [ "celsius", "celsius-diff" ];
}

export function convertValue(sourceValue, sourceUnit, temperaturePreference = null) {
  temperaturePreference = temperaturePreference ?? store.sessions[0].system.temperatureUnit.value;

  let preferredUnits = getPreferredUnits(temperaturePreference);
  let conversion = conversions().find(conversion => conversion.unitFrom == sourceUnit && preferredUnits.includes(conversion.unitTo));
  if (conversion)
    return conversion.convertValue(sourceValue);
  else
    return sourceValue;
}

export function convertUnit(sourceUnit, temperaturePreference = null) {
  temperaturePreference = temperaturePreference ?? store.sessions[0].system.temperatureUnit.value;

  let preferredUnits = getPreferredUnits(temperaturePreference);
  let conversion = conversions().find(conversion => conversion.unitFrom == sourceUnit && preferredUnits.includes(conversion.unitTo));
  if (conversion)
    return conversion.unitTo;
  else
    return sourceUnit;
}

export function unitHtml(unit) {
  let unitsInfo = store.sessions[0].system.units.value.map(([key, value]) => value);
  let unitInfo = unitsInfo.find(unitInfo => unitInfo.value == unit);
  return unitInfo?.unitSymbol;
}

export function convertedUnitHtml(unit, temperaturePreference = null) {
  temperaturePreference = temperaturePreference ?? store.sessions[0].system.temperatureUnit.value;
  
  let convertedUnit = convertUnit(unit, temperaturePreference);
  return unitHtml(convertedUnit);
}

export function unconvertValue(convertedValue, convertedUnit) {
  let conversion = conversions().find(conversion => conversion.unitTo == convertedUnit);
  if (conversion)
    return conversion.unconvertValue(convertedValue);
  else
    return convertedValue;
}

export function unitRound(value, unit, precision = 0.1) {
  switch (unit) {
    case "celsius": 
    case "celsius-diff":
      return roundToNearestFixedRange(value, 0.1, 0.05);
        
    default:
      return roundToNearestFixed(value, precision);
  }
}

export function unitRoundForStatusPage(value, unit, precision = 0.1) {
  switch (unit) {
    case "celsius": 
    case "celsius-diff":
      return roundToNearestFixed(value, 0.05);
        
    default:
      return roundToNearestFixed(value, precision);
  }
}

export function createValueAndUnitHtml(value, unit, precision) {
  let convertedValue = convertValue(value, unit);
  let convertedUnit = convertUnit(unit);
  return `${unitRound(convertedValue, convertedUnit, precision)} ${unitHtml(convertedUnit)}`;
}